import { render, staticRenderFns } from "./ManageCourseEventDays.vue?vue&type=template&id=6ea1548d&scoped=true"
import script from "./ManageCourseEventDays.vue?vue&type=script&lang=ts"
export * from "./ManageCourseEventDays.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea1548d",
  null
  
)

export default component.exports